<vbox class="devices-window" flex>
  <DeviceSetup />
</vbox>

<script lang="ts">
  import DeviceSetup from "../../Meet/Setup/DeviceSetup.svelte";
</script>

<style>
  .devices-window {
    align-items: center;
    justify-content: end;
  }
</style>
